// src/components/homepage_content/MatchCard.jsx
import React from 'react';
import BetButton from '../common/BetButton';

const MatchCard = ({ match }) => {
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: false 
    });
  };

  return (
    <div className="bg-gray-900 rounded-xl p-4 hover:bg-gray-800 transition-colors duration-200">
      {/* Match Header */}
      <div className="flex justify-between items-center mb-3">
        <div className="text-xs text-gray-400">{match.league}</div>
        <div className="text-xs text-gray-400">{formatTime(match.time)}</div>
      </div>
      
      {/* Teams */}
      <div className="flex justify-between items-center mb-4">
        <div className="text-sm font-medium text-white">{match.homeTeam}</div>
        <div className="text-xs text-gray-400 px-2">VS</div>
        <div className="text-sm font-medium text-white">{match.awayTeam}</div>
      </div>
      
      {/* Betting Odds */}
      <div className="flex space-x-2">
        <BetButton
          odds={match.odds.home}
          selection="1"
          match={`${match.homeTeam} vs ${match.awayTeam}`}
          matchId={match.id}
          sport={match.sport}
          type="home"
        />
        
        {match.odds.draw && (
          <BetButton
            odds={match.odds.draw}
            selection="X"
            match={`${match.homeTeam} vs ${match.awayTeam}`}
            matchId={match.id}
            sport={match.sport}
            type="draw"
          />
        )}
        
        <BetButton
          odds={match.odds.away}
          selection="2"
          match={`${match.homeTeam} vs ${match.awayTeam}`}
          matchId={match.id}
          sport={match.sport}
          type="away"
        />
      </div>
      
      {/* Additional Markets */}
      {match.additionalMarkets && (
        <div className="mt-3 pt-3 border-t border-gray-800">
          <div className="flex space-x-2">
            {match.additionalMarkets.map((market, index) => (
              <button
                key={index}
                className="flex-1 py-1.5 bg-gray-800 hover:bg-gray-700 rounded text-xs text-gray-300 transition-colors"
                onClick={() => {
                  // Handle additional market selection
                  console.log('Additional market:', market);
                }}
              >
                {market.name}: {market.odds}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MatchCard;